import { equals } from "../fable-library-js.4.24.0/Util.js";
import { toList } from "../fable-library-js.4.24.0/Seq.js";

export function objectHas(keys, x) {
    return equals(keys, toList(Object.keys(x)));
}

